import React from "react";
import Hero from "../../components/sections/Home/Hero";
import KostradRunSection from "../../components/sections/Home/KostradRunSection";
import RacePackSection from "../../components/sections/Home/RacePackSection";
import PricingSection from "../../components/sections/Home/PricingSection";
// import About from "../../components/sections/Home/About";
// import TotalPrize from "../../components/sections/Home/TotalPrize";
// import Podium from "../../components/sections/Home/Podium";
// import Sponsor from "../../components/sections/Home/Sponsor";

export default function Index() {
    return (
        <div className="bg-main bg-cover bg-left-top bg-repeat-y">
            <Hero />
            <KostradRunSection />
            <RacePackSection />
            <PricingSection />
            {/* <About /> */}
            {/* <Podium /> */}
            {/* <TotalPrize /> */}
            {/* <Sponsor /> */}
        </div>
    );
}
